// src/dashboard/reducers/filters.js
import { SET_FILTERS, RESET_FILTERS } from "../actions/filters";

function defaultDateRange() {
  const end = new Date();
  end.setHours(23, 59, 59, 999);
  const start = new Date();
  start.setDate(start.getDate() - 6);
  start.setHours(0, 0, 0, 0);
  return { from: start.toISOString(), to: end.toISOString() };
}

const initialState = {
  dateRange: defaultDateRange(),
  channel: null,
  area: null,
  workflow: null,
};

export default function filtersReducer(state = initialState, action) {
  switch (action.type) {
    case SET_FILTERS:
      return { ...state, ...action.payload.filters };
    case RESET_FILTERS:
      return initialState;
    default:
      return state;
  }
}
